import { render } from "./LoaderCar.vue?vue&type=template&id=df18a408&scoped=true"
import script from "./LoaderCar.vue?vue&type=script&lang=js"
export * from "./LoaderCar.vue?vue&type=script&lang=js"

import "./LoaderCar.vue?vue&type=style&index=0&id=df18a408&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df18a408"]])

export default __exports__